<template>
  <main class="dashboard links">
    <div class="mb-4 d-flex">
      <h2><b>Список слайдов</b></h2>
      <router-link :to="{name: 'pptx_slide_add'}" class="btn btn-sm btn-outline-dark ms-auto">Добавить слайд</router-link>

    </div>


    <div class="card">

      <div class="card-body">
            <div class="row" style="flex-wrap: nowrap">
              <div class="col"> №</div>
              <div class="col-5">Название</div>
              <div class="col">Сортировка</div>
              <div class="col">Для всех стран</div>
              <div class="col">Тип проекта</div>
              <div class="col">Уровень в содержании</div>
              <div class="col">Активен</div>
            </div>
             <draggable v-model="layouts" item-key="id" :sort="true">
      <template #item="{element, index}" class="row">
        <div class="row" style="flex-wrap: nowrap;">
                <div class="col"><i class="bi bi-grip-vertical"></i>{{ index + 1 }}</div>
                <div class="col-5">
                  <router-link :to="{name: 'pptx_slide_detail', params: {slide_id: element.id}}">{{
                      element.name
                    }}
                  </router-link>
                </div>
                <div class="col">
                  <input type="text" class="form-control" style="width: 50px" v-model="element.sort">
                </div>
                <div class="col">
                <div class="form-check form-switch ms-1 pt-2">
                    <input class="form-check-input" v-model="element.for_country" type="checkbox" role="switch"
                           :id="'for_country'+element.id">
                    <label class="form-check-label" :for="'for_country'+element.id"></label>
                  </div>
                </div>
                <div class="col">
                  <MultiSelect
                      v-model="element.project_types"
                      :options="[{id: 'audit', name: 'Аудит'},{id: 'active', name: 'Активный'},]"
                      :multi="true"
                      :only_value="true"
                      name=""></MultiSelect>
                </div>
                <div class="col">
                  <input type="text" class="form-control" style="width: 50px" v-model="element.ToC_level">
                </div>
                <div class="col">
                  <div class="form-check form-switch ms-1 pt-2">
                    <input class="form-check-input" v-model="element.is_enabled" type="checkbox" role="switch"
                           :id="'enabled'+element.id">
                    <label class="form-check-label" :for="'enabled'+element.id"></label>
                  </div>
                </div>
                </div>
      </template>
    </draggable>

        </div>
    </div>


  </main>
</template>

<script>
import {SlideApi} from "@/api/slides";
import ProjectInfo from "@/components/ProjectInfo.vue";
import draggable from "vuedraggable";

export default {
  name: 'SlideList',
  components: {draggable, ProjectInfo},
  data() {
    return {
      layouts: []
  }
  },

  mounted: function () {
    SlideApi.slides().then(response => this.layouts = response.filter(x=>x.id>=0))
  },
}

</script>

<style scoped lang="scss">

.draggable {
  cursor: move;
  user-select: none;

  &.dragging {
    opacity: 0.5;
    position: absolute;

  }

  .resize-handle {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    background: #555;
    cursor: nwse-resize;
  }
}


.screen-list {
  display: flex;
  gap: 30px;

  ul {
    height: 80vh;
    overflow-y: scroll;
  }
}

.layout-wrapper {

  .layout {
    display: block;
    border: 1px solid #999;
    position: relative;

    .placeholder {
      z-index: 2;
      border: 1px solid #999;
      position: absolute;
      display: block;
      background: repeating-linear-gradient(
              45deg,
              rgba(255, 0, 0, 0.2),
              rgba(255, 0, 0, 0.2) 10px,
              transparent 10px,
              transparent 20px
      );

      span {
        background: #ccc;
        border-radius: 5px;
        color: #000000;
        font-size: 9px;
        padding: 0;
        line-height: 10px;
        top: 0;
        position: absolute;
      }
    }

    .icons {
      z-index: 1;
      border: 1px solid #000;
      position: absolute;
      display: block;
      background: #74637f;

    }
  }
}

.icon {
  background: repeating-linear-gradient(
          45deg,
          rgba(53, 102, 121, 0.5),
          rgba(53, 102, 121, 0.5) 10px,
          transparent 10px,
          transparent 20px
  );
  //position: absolute;
}
.card-body div:not(.row):last-child{
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.card-body div.row:first-child{
  font-weight: bold;
}
</style>
